import React, { useEffect, useState } from "react";
import "./Floatingbuttons.css";

const FloatingButtons = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/917693890243"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>
        <span className="tooltip-text">Chat on WhatsApp</span>
      </a>

      {/* Scroll To Top Button */}
      {showScroll && (
        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Back to Top"
        >
          <i className="bi bi-arrow-up"></i>
          <span className="tooltip-text">Back to Top</span>
        </button>
      )}
    </>
  );
};

export default FloatingButtons;
